document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.grid-container[data-mobile-layout="carousel"]');
  if (container) {
    const prevButton = container.parentElement.querySelector('.arrow.prev');
    const nextButton = container.parentElement.querySelector('.arrow.next');

    prevButton.addEventListener('click', () => {
      container.scrollBy({ left: -container.offsetWidth, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      container.scrollBy({ left: container.offsetWidth, behavior: 'smooth' });
    });
  }
});